import React, { memo, ReactNode } from 'react';
//import Image from '@plasma/ui.display.image';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useAllCompaniesHook from './all-companies.hook';
import * as styled from './all-companies.styles';
import themes from './themes';
import EditableTable from '../../components/edit-table';
import TopBar from '../../components/top-bar/top-bar';
import Modal from '@plasma/ui.layout.modal/dist/modal';
import Input from '@plasma/ui.input.input';
import TopBarThemed from '../../components/top-bar-themed';

export interface AllCompaniesProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = AllCompaniesProps & ThemeOverride;

function AllCompanies(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    dataForColumns,
    errorMessage,
    setErrorMessage,
    columnNames,
    handleSelectedRow,
    modalVisible,
    handleSaveFromModal,
    handleModalCancel,
    formData,
    dataChangedHandler,
    zipCodeErrorMessage,
    setZipCodeErrorMessage,
  } = useAllCompaniesHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.AllCompanies className={`all-companies ${className ?? ''}`.trim()} style={style}>
        <TopBarThemed
          topHeading={t("manage-customer-plant")}
        />
        <Modal
          title={'Edit Customer + Plant'}
          width={'1600px'}
          okText="Save "
          cancelText="Cancel"
          visible={modalVisible}
          onCancel={() => handleModalCancel()}
          onOk={() => handleSaveFromModal()}
          destroyOnClose={true}
        >
          <div style={{ background: 'linear-gradient(to top left, #f0f0f5, #33adff34)' }}>
            <br></br>
            <div style={{ margin: '12px' }}>
              <div style={{ backgroundColor: 'lightgray', borderRadius: '0.5em', height: '2em', padding: '3px' }}>
                Company Detail
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Company Name :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.companyname} disabled
                  onChange={(e)=>dataChangedHandler("companyname", e.target.value)}/>
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Company Full Name :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.companyfullname}
                  onChange={(e)=>dataChangedHandler("companyfullname", e.target.value)} />
                </div>
              </div>
              <br></br>
              <div style={{ backgroundColor: 'lightgray', borderRadius: '0.5em', height: '2em', padding: '3px' }}>
                Plant Detail
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Plant Code Name :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.plantcodename} disabled />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Schema Name :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.schemaname} disabled />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Location Code Name :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.locationcodenname}
                  onChange={(e)=>dataChangedHandler("locationcodenname", e.target.value)}/>
                </div>
              </div>
              <br></br>
              <div style={{ backgroundColor: 'lightgray', borderRadius: '0.5em', height: '2em', padding: '3px' }}>
                Address Detail
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Address 1:
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.address1}
                  onChange={(e)=>dataChangedHandler("address1", e.target.value)} />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Address 2 :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.address2}
                  onChange={(e)=>dataChangedHandler("address2", e.target.value)} />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Address 3 :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.address3}
                  onChange={(e)=>dataChangedHandler("address3", e.target.value)} />
                </div>
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Province:
                  </label>
                  <Input id="cid" style={{ width: '300px', marginLeft: '5px' }} type="text" value={formData.province}
                  onChange={(e)=>dataChangedHandler("province", e.target.value)} />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    State :
                  </label>
                  <Input id="cid" style={{ width: '300px', marginLeft: '19px' }} type="text" value={formData.state}
                  onChange={(e)=>dataChangedHandler("state", e.target.value)} />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Country :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.country}
                  onChange={(e)=>dataChangedHandler("country", e.target.value)} />
                </div>
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }} >
                    Continent :
                  </label>
                  <Input
                    id="cid"
                    style={{ width: '300px', marginLeft: '-6px' }}
                    type="text"
                    value={formData.continent}
                    onChange={(e)=>dataChangedHandler("continent", e.target.value)}
                  />
                </div>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Zipcode :
                  </label>
                  <Input id="cid" style={{ width: '300px' }} type="text" value={formData.zipcode}
                  onChange={(e)=>{
                    const isValid = /^[\d+]*$/.test(e.target.value)
                    if (isValid) {
                      dataChangedHandler("zipcode", e.target.value);
                      setZipCodeErrorMessage('');
                    } else {
                      setZipCodeErrorMessage('Please enter only numbers');
                    }
                  }} />
                  {zipCodeErrorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{zipCodeErrorMessage}</div>}
                </div>
              </div>
              <br></br>
              <div style={{ backgroundColor: 'lightgray', borderRadius: '0.5em', height: '2em', padding: '3px' }}>
                Contact Detail
              </div>
              <br></br>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                  <label id="cid" style={{ marginRight: '14px', fontWeight: 'bold' }}>
                    Contact No 1 :
                  </label>
                  <Input
                    id="cid"
                    style={{ width: '300px' }}
                    type="tel"
                    value={formData.contactno1}
                    onChange={(e)=>{
                      const isValid = /^[\d+]*$/.test(e.target.value)
                      if (isValid) {
                        dataChangedHandler("contactno1", e.target.value);
                        setErrorMessage('');
                      } else {
                        setErrorMessage('Please enter only digits and +');
                      }
                    }}
                  />
                  {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                </div>
                <div style={{ display: 'flex' }}>
                  <label style={{ marginRight: '14px', fontWeight: 'bold' }}>Contact No 2 :</label>
                  <Input
                    style={{ width: '300px' }}
                    type="tel"
                    value={formData.contactno2}
                    onChange={(e)=>{
                      const isValid = /^[\d+]*$/.test(e.target.value)
                      if (isValid) {
                        dataChangedHandler("contactno2", e.target.value);
                        setErrorMessage('');
                      } else {
                        setErrorMessage('Please enter only digits and +');
                      }
                    }}
                  />
                  {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                </div>
              </div>
              <br></br>
            </div>
          </div>
        </Modal>
        <EditableTable
          tableData={dataForColumns}
          tableColumns={columnNames}
          Table_Header=""
          hiddenColumns={['id', 'remarks', 'isactive']}
          stillHiddenColumns={['id']}
          showActions_ext={false}
          handleSelection={handleSelectedRow}
          saveReturnType={'row'}
          allowSelection={true}
          //  selectInputReturnType={'value'}
          onlyAddableFields={['plantcodename', 'companyname', 'schemaname']}
          // Inline add/edit/delete all posted to a nonexistent AddMasterCompany endpoint - the only
          // working path is row-click -> modal -> UpdateCompanyInfo (handleSelectedRow above), so the
          // grid's own mutation actions are disabled rather than left silently failing.
          ButtonsVisible={{
            Edit: false,
            MoveUp: false,
            InsertUp: false,
            InsertDown: false,
            MoveDown: false,
            Delete: false,
          }}
        />

        {children}
      </styled.AllCompanies>
    </ThemeProvider>
  );
}

export default memo(AllCompanies) as unknown as typeof AllCompanies;
